import type { ObjectData } from '@/domain';

export const generateStructuredData = (objectData: ObjectData): VacationRentalJsonLd | null => {
    // Fields required by google for a structured data VacationRental-object:
    // https://developers.google.com/search/docs/appearance/structured-data/vacation-rental#structured-data-type-definitions
    const { noOfBeds, adId, images, location, heading } = objectData;
    const parsedNoOfBeds = Number(noOfBeds);
    const occupancyValue = Number.isNaN(parsedNoOfBeds) ? null : parsedNoOfBeds;

    if (!heading || !occupancyValue) {
        return null;
    }
    return {
        '@context': 'https://schema.org',
        '@type': 'VacationRental',
        name: heading,
        identifier: String(adId),
        image: images.map((image) => image.src),
        latitude: location.latitude,
        longitude: location.longitude,
        containsPlace: {
            '@type': 'Accommodation',
            occupancy: {
                '@type': 'QuantitativeValue',
                value: occupancyValue,
            },
        },
        address: {
            '@type': 'PostalAddress',
            addressCountry: location.countryCode,
            addressLocality: location.locality,
        },
    };
};

type JsonLdBase = {
    '@context': 'https://schema.org';
    '@type': string;
};

type VacationRentalJsonLd = JsonLdBase & {
    '@type': 'VacationRental';
    name: string;
    identifier: string;
    image: string[];
    latitude: number;
    longitude: number;
    containsPlace: {
        '@type': 'Accommodation';
        occupancy: {
            '@type': 'QuantitativeValue';
            value: number;
        };
    };
    address: {
        '@type': 'PostalAddress';
        addressCountry: string;
        addressLocality: string;
    };
};
